export default __webpack_public_path__ + "static/media/Waterpurifier.9cd19dd3.png";